<template>
    <div class="box">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-else class="box-offset">
            <div class="box-ttl-wrap">
                <div class="box-ttl ">
                    Upload Document for {{ userInfo.name }} {{ userInfo.last_name }}
                </div>
            </div>
            <div class="buttons--row">
                <div class="search--block">

                    <button
                        class="search--block-btn"
                        type="submit"
                        @click="getApplicantAttachments">
                        <img src="/img/svg/icons-search.svg" alt="">
                    </button>

                    <input
                        type="search"
                        class="search--block-txt"
                        v-model="filters.search"
                        @input="handleSearch"
                    />
                </div>
                <div class="info-text">
                    <b>Note:</b> Expiration dates in orange are for pending expiration in 30 days or less. Red dates are
                    already expired.
                </div>
                <a
                    href="javascript:void(0)"
                    class="btn btn--middle"
                    @click="showCustomModal('file', 1)">+ Add Files</a>

                <AddNewFileModal
                    :id="getCustomModalId('file', 1)"
                    :user-id="userInfo.id"
                    @confirm="uploadApplicantFile"
                ></AddNewFileModal>

            </div>
            <div class="table-holder table-responsive">
                <table class="table">
                    <thead>
                    <tr>
                        <th>Download</th>
                        <th>
                            <nobr>Date Added</nobr>
                        </th>
                        <th>
                            <nobr>Expiration Date</nobr>
                        </th>
                        <th class="text-right">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="file in applicantAttachments"
                        :key="file.id"
                    >
                        <td v-if="activeFile.id === file.id">
                            <div class="form-group form-group-1 mb-0 " style="min-width: 10rem">
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="file.original_filename">
                            </div>
                        </td>

                        <td v-else>
                            {{ file.original_filename }}
                        </td>

                        <td>
                            <div class="text-14 color--text-gray">
                                {{ formatDate(file.created_at) }}
                            </div>
                        </td>

                        <td v-if="activeFile.id === file.id">
                            <div class="form-group form-group-1 mb-0 " style="min-width: 10rem">
                                <input
                                    type="date"
                                    class="form-control"
                                    v-model="file.expiration_date">
                            </div>
                        </td>
                        <td v-else>
                            <div
                                class="text-14"
                                :class="calcExpirationDate(file.expiration_date)"
                                v-if="file.expiration_date">
                                {{ file.expiration_date }}
                            </div>
                            <div v-else class="text-14">
                                N/A
                            </div>
                        </td>

                        <td class="text-right">
                            <div class="action-block">

                                <a :href="`/uploads/${file.file_path}`"
                                   class="color--secondary"
                                   title="View"
                                   target="_blank"
                                ><i class="fas fa-eye"></i>
                                </a>

                                <a href="javascript:void(0)"
                                   v-if="activeFile.id === file.id"
                                   @click="saveChanges(file)"
                                   class="edit-link img-btn" title="Save">
                                    <img src="/img/svg/check-5.svg" alt="save">
                                </a>

                                <a href="javascript:void(0)"
                                   v-else
                                   class="edit-link" title="Edit"
                                   @click="editFile(file)"
                                >
                                    <img src="/img/svg/icons-pen.svg" alt="edit">
                                </a>

                                <a :href="`/uploads/${file.file_path}`"
                                   class="img-btn"
                                   title="Download"
                                   :download="`${file.original_filename}`">
                                    <img src="/img/svg/icons-download.svg" alt="download">
                                </a>

                                <button
                                    class="img-btn delete-link"
                                    @click="showDeleteModal(file.id, 'attachment')"
                                ><img src="/img/svg/on.svg" alt=""></button>
                                <ActionModal confirm-text="Yes"
                                             reject-text="No"
                                             :modalId="getDeleteModalId(file.id, 'attachment')"
                                             @confirm="deleteAttachment(file.id)">
                                    <template #body>
                                        <div class="text-center mb-4">
                                            <h4>
                                                Are you sure you want <br> to delete this item?
                                            </h4>
                                        </div>
                                    </template>
                                </ActionModal>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <Pagination
                class="ml-1 mr-1"
                :currentPage="pagination.current_page"
                :lastPage="pagination.last_page"
                @changeItemsPerPage="changeItemsPerPage"
                @changePage="changePage"/>
        </div>
    </div>
</template>

<script>
import AddNewItemModal from "../../../../../../resources/js/components/AddNewItemModal.vue";
import AddNewFileModal from "../../../../../../resources/js/components/AddNewFileModal.vue";
import PersonalDetailsService from "../../../../AppUser/resources/js/services/PersonalDetailsService";
import ApplicantsServices from "../services/ApplicantsServices";
import ActionModal from "../../../../../../resources/js/components/ActionModal.vue";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";
import SortDirectionHandler from "../../../../../../resources/js/mixins/SortDirectionHandler";
import PaginationHandler from "../../../../../../resources/js/mixins/PaginationHandler";
import _ from "lodash";
import Pagination from "../../../../../../resources/js/components/Pagination.vue";

export default {
    name: 'Attachments',
    components: {Pagination, ActionModal, AddNewFileModal, AddNewItemModal},
    props: {
        userInfo: {
            type: Object
        }
    },
    mixins: [DateConverter, ModalHandler, SortDirectionHandler, PaginationHandler ],
    data() {
        return {
            activeFile: {},
            applicantAttachments: [],
            expDays: null,
            fileName: null,
            fileExpire: null,
            filters: {
                search: '',
                page: 1,
                perPage: 10
            },
            loading: true,
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    methods: {
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
        delayedSearch: _.debounce(function() {
            this.getApplicantAttachments(this.filters)
        }, 500),
        getList(filters) {
            this.getApplicantAttachments(filters)
        },
        async deleteAttachment(id) {
            this.$showLoadingMessage()
            this.applicantAttachments = this.applicantAttachments.filter((comment) => comment.id !== id)
            try {
                this.$showSuccessMessageDelete('Your attachment has been successfully deleted');
                await ApplicantsServices.deleteApplicantAttachment(this.userInfo.id, id)
            } catch (error) {
                this.$showErrorMessage('Your attachment was not deleted. Please try again.');
            }
        },
        editFile(file) {
            this.activeFile = file
        },
        async getApplicantAttachments() {
            try {
                const {data: response} = await ApplicantsServices.getApplicantsAttachments(this.userInfo.id, this.filters)
                this.applicantAttachments = response.data
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
                this.loading = false
            } catch (e) {
                console.error(e)
            }
        },
        async saveChanges(file) {
            this.$showLoadingMessage()
            try {
                await this.uploadApplicantFile(file)
                this.activeFile = {}
                await this.getApplicantAttachments()
                this.$showSuccessMessage('Your Comment was updated!')
            } catch (e) {
                this.$showErrorMessage('Your attachment was not updated. Please try again.');
            }
        },
        async uploadApplicantFile(payload) {
            this.$showLoadingMessage()
            try {
                await ApplicantsServices.add_editApplicantsAttachments(this.userInfo.id, payload.id, payload)
                await this.getApplicantAttachments()
                this.$showSuccessMessage('Your file was uploaded!')
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Your file was not uploaded. Please try again')
            }

        },
    },
    mounted() {
        this.getApplicantAttachments()
    }
}

</script>

<style scoped>

</style>
